import { createFileRoute } from "@tanstack/react-router";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/$")({
  head: ({ match }) => {
    const path = match.pathname;
    const seo = pageSeo({
      path,
      title: "Page Not Found | CRS Energy",
      description: "The page you're looking for doesn't exist or has been moved.",
    });
    return {
      ...seo,
      meta: [...seo.meta, { name: "robots", content: "noindex, nofollow" }],
    };
  },
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-primary">404</h1>
        <h2 className="mt-4 text-xl font-semibold">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6">
          <a
            href="/"
            className="inline-flex items-center justify-center rounded-full bg-accent px-6 py-3 text-sm font-semibold text-accent-foreground hover:bg-accent/90"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}
